import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { QuoteDocGenData } from "./quote-doc-gen-data.model";
import { RepaymentOption } from "./repayment-option.model";
import { handleError } from "../../shared/handle-error";

@Injectable()
export class DocumentService {
    private enquiriesUrl = "api/enquiries";  // url to web api

    constructor(private http: HttpClient) {}

    downloadApplicationForm(enquiryID: number): Observable<HttpResponse<Blob>> {
        const url = `${this.enquiriesUrl}/${enquiryID}/application`;
        return this.http
            .get(url, {
                responseType: "blob",
                observe: "response", // observing the full response object since we want to extract the generated fileName from a http header
                headers: new HttpHeaders().set("Accept", "application/pdf")
            })
            .pipe(catchError(handleError));
    }

    downloadQuotePdf(enquiryID: number, docGenData: QuoteDocGenData): Observable<HttpResponse<Blob>> {
        const url = `${this.enquiriesUrl}/${enquiryID}/pdf`;
        return this.http
            .post(url, docGenData, {
                responseType: "blob",
                observe: "response", // observing the full response object since we want to extract the generated fileName from a http header
                headers: new HttpHeaders().set("Accept", "application/pdf")
            })
            .pipe(catchError(handleError));
    }

    prepareQuoteDocGenData(showAssetCost: boolean, checkboxValues: boolean[], repaymentOptions: RepaymentOption[]): QuoteDocGenData {
        // includeRepaymentOpts will contain all the repayment options, but unchecked ones will be null
        const includeRepaymentOpts: RepaymentOption[] = checkboxValues.map(
            (checked: boolean, index) => {
                if (checked) {
                    return Object.assign({}, repaymentOptions[index]);
                }
            });

        const docGenData: QuoteDocGenData = {
            showAssetCost: showAssetCost,
            repaymentOptions: includeRepaymentOpts.filter(r => r != null)
        };

        return docGenData;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/enquiry/shared/document.service.ts